import { createAuthBaseQuery } from "@iotos/ims-auth-sdk/redux";
import type { RetryOptions } from "@reduxjs/toolkit/query";

import { imsAuthService } from "../../authentication/shared/ims-auth-service";
import { API_ENDPOINT } from "../../config/api";

/**
 * Базовый запрос из SDK: cookie-сессия (`credentials: "include"`),
 * CSRF-заголовок из `getAuthHeaders()` и 401 → `handleUnauthorized()`.
 */
const imsBaseQuery = createAuthBaseQuery(API_ENDPOINT, imsAuthService, {
  maxRetries: 1,
});

/**
 * Повторять можно только чтение: у RTK дефолтное условие смотрит лишь на номер
 * попытки, поэтому упавшие POST/PUT/DELETE уходили бы повторно.
 *
 * TODO(IMS-SDK): `createAuthBaseQuery` не принимает `retryCondition` в конфиге —
 * попросить команду IMS добавить его (или сразу не повторять мутации внутри SDK)
 * и убрать обёртку ниже.
 */
const shouldRetryRequest: NonNullable<RetryOptions["retryCondition"]> = (
  _error,
  _args,
  { attempt, baseQueryApi, extraOptions }
) => {
  if (baseQueryApi.type === "mutation") {
    return false;
  }

  const maxRetries = extraOptions?.maxRetries ?? 1;
  return attempt <= maxRetries;
};

/**
 * `retryCondition` передаётся через `extraOptions`: RTK накладывает их поверх
 * настроек обёртки `retry`, так что условие доезжает и без правки SDK.
 */
export const baseQuery: typeof imsBaseQuery = (args, api, extraOptions) =>
  imsBaseQuery(args, api, { retryCondition: shouldRetryRequest, ...extraOptions });
